<input
  #clientLogoInput
  id="clientLogoInput"
  class="d-none"
  type="file"
  accept="image/*"
  (change)="handleClientLogoInput($event.target)"
/>
<div
  id="clientDetail"
  class="pt-2"
  [ngStyle]="{
    'padding-bottom': '80px',
  }"
>
  @if (isAdmin && detailData?.id) {
    <div class="me-lg-2 mb-2 text-end px-3 d-none">
      @if (detailData?.company_stats?.active_jobs_exists) {
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-title="Unable to delete, you have active tasks or jobs for this client."
        >
          <button class="btn btn-sm btn-danger" disabled id="clientDeleteBtn">
            Delete Client
            <i class="fa-solid fa-circle-info text-secondary ms-1"></i>
          </button>
        </span>
      } @else {
        <button
          class="btn btn-sm btn-danger"
          [disabled]="detailData?.company_stats?.active_jobs_exists"
          (click)="
            detailData?.company_stats?.active_jobs_exists
              ? ''
              : archiveUnarchive()
          "
          id="clientDeleteBtn"
        >
          Delete Client
        </button>
      }
    </div>
  }

  <div class="details-card mb-4">
    <div class="row row-cols-1 row-cols-lg-3">
      <div class="col-12 col-lg-5">
        <div>
          <dl class="d-flex align-items-center column-gap-5">
            <div>
              <div
                class="fs-4 pe-2 d-flex align-items-center mb-1 gap-3"
                id="editClientName"
              >
                {{ detailData?.company_name }}
                @if (isAdmin || isDispatchUser) {
                  <div class="d-flex flex-wrap gap-2 gap-lg-1">
                    <div class="d-flex">
                      <span
                        class="ms-3 edit-button"
                        (click)="
                          isAdmin || isDispatchUser ? openEditTemplate() : ''
                        "
                      ></span>
                    </div>

                    @if (isAdmin && detailData?.id) {
                      <div class="d-flex">
                        <span
                          class="ms-3 del-button"
                          [ngClass]="
                            detailData?.company_stats?.active_jobs_exists
                              ? 'disabled-button'
                              : ''
                          "
                          (click)="
                            detailData?.company_stats?.active_jobs_exists
                              ? ''
                              : archiveUnarchive()
                          "
                        ></span>
                        @if (detailData?.company_stats?.active_jobs_exists) {
                          <span
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Unable to delete, you have active tasks or jobs for this client."
                          >
                            <i
                              class="fa-solid fa-circle-info text-secondary opacity-75 small"
                            ></i>
                          </span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              @if (detailData?.custom_address) {
                <dd class="gt-multi-line align-items-center">
                  {{ detailData?.custom_address }}
                  <span
                    class="ms-3 edit-button"
                    (click)="
                      isAdmin || isDispatchUser ? openEditTemplate() : ''
                    "
                  ></span>
                </dd>
              } @else if (detailData?.address?.full_address) {
                <dd class="gt-multi-line align-items-center">
                  {{ detailData?.address?.full_address }}
                  <span
                    class="ms-3 edit-button"
                    (click)="
                      isAdmin || isDispatchUser ? openEditTemplate() : ''
                    "
                  ></span>
                </dd>
              }
            </div>
          </dl>
        </div>

        <dl>
          <div class="d-flex align-items-lg-top flex-column flex-lg-row gap-2">
            <div>
              <div
                class="d-flex align-items-center pe-2 mb-2"
                role="button"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-title="When checked, show client details on reports instead of yours."
              >
                <input
                  class="d-flex align-items-center"
                  type="checkbox"
                  id="isSubContractingFor"
                  [checked]="detailData?.is_subcontracting"
                  (change)="updateSubContractorStatus($event)"
                  role="button"
                /><label
                  class="ms-1"
                  for="isSubContractingFor"
                  [ngClass]="detailData?.is_subcontracting ? 'fw-semibold' : ''"
                  >Prime Contractor
                </label>
                <span class="ms-2">
                  <i class="fa-solid fa-circle-info fs-5 text-success"></i>
                </span>
              </div>

              @if (detailData?.id && detailData?.is_subcontracting) {
                <div>
                  @if (clientDetailData?.prime_contractor_users?.length) {
                    <div class="d-flex gap-2 align-items-center mb-2">
                      <dt>Prime Contractor Login</dt>
                    </div>
                    <div
                      class="d-flex align-items-center pe-2 mb-2 small"
                      role="button"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="If ticked, jobs that have not yet been reviewed and sent out will also be published."
                    >
                      <input
                        class="d-flex align-items-center"
                        type="checkbox"
                        id="pcShowAllJobsCheckbox"
                        [checked]="
                          detailData?.additional_info?.pc_show_all_jobs
                        "
                        (change)="showAllJobsToPCUsers($event)"
                        role="button"
                      /><label
                        class="ms-1"
                        for="pcShowAllJobsCheckbox"
                        [ngClass]="
                          detailData?.additional_info?.pc_show_all_jobs
                            ? 'fw-semibold'
                            : ''
                        "
                        >Ignore Review Status
                      </label>
                      <span class="ms-2">
                        <i class="fa-solid fa-circle-info text-danger"></i>
                      </span>
                    </div>
                    <dd class="overflow-25vh row row-cols-auto mb-2">
                      @for (
                        user of clientDetailData?.prime_contractor_users;
                        track $index
                      ) {
                        <div
                          class="border px-2 py-1 rounded bg-secondary-subtle text-dark d-flex align-items-center gap-3"
                        >
                          <div class="flex-grow-1">
                            <div class="fw-semibold mb-2">
                              {{ user?.full_name }}
                            </div>
                            <div
                              class="small d-flex justify-content-between gap-3"
                            >
                              <div>
                                {{ user?.email }}
                              </div>
                              @if (user?.mobile_number) {
                                <div>
                                  {{ user?.mobile_number }}
                                </div>
                              }
                            </div>
                          </div>
                          <div>
                            <span (click)="removePrimeContractorUser(user)">
                              <i
                                class="fa-solid fa-circle-minus text-danger fs-5"
                              ></i>
                            </span>
                          </div>
                        </div>
                      }
                    </dd>
                  } @else {
                    <div
                      class="bg-primary-subtle border-0 rounded p-2 text-dark text-center small hover fw-semibold"
                      role="button"
                      (click)="createNewPrimeContractorUser()"
                    >
                      + Setup Prime Contractor Login
                    </div>
                  }
                </div>
              }
            </div>

            @if (
              !detailData?.company_logo_url && detailData?.is_subcontracting
            ) {
              <div>
                <dl>
                  <dt class="mb-2">Custom Letterhead Logo</dt>
                  <button
                    class="btn btn-sm btn-outline-success"
                    (click)="openCamPopup()"
                  >
                    Upload Logo
                  </button>
                </dl>
              </div>
            }

            @if (
              detailData?.company_logo_url && detailData?.is_subcontracting
            ) {
              <dl>
                <dt class="d-flex align-items-center">
                  <span> Letterhead Logo </span>
                  <span (click)="removeClientLogo()">
                    <i class="fa-solid fa-circle-minus text-danger fs-5"></i>
                  </span>
                </dt>
                <div class="p-2">
                  <img
                    id="clientLogo"
                    class="w-auto border bg-white"
                    src="{{ detailData?.company_logo_url }}"
                    alt="Letterhead Logo"
                    style="max-height: 100px"
                  />
                </div>
                <div class="d-flex gap-2 flex-column flex-lg-row d-none">
                  <button
                    class="btn btn-sm btn-primary d-none"
                    (click)="openCamPopup()"
                  >
                    Update
                  </button>
                </div>
              </dl>
            }
          </div>
        </dl>

        @if (isAdmin || isDispatchUser || detailData?.information?.trim()) {
          <div>
            <!--the outer div is necessary for correct padding and matching other div dls-->
            <dl id="clientInformation">
              @if (detailData?.information?.trim()) {
                <dt>Client Information</dt>
              }
              <dd class="gt-multi-line">
                @if (detailData?.information?.trim()) {
                  {{ detailData?.information }}
                  @if (
                    (isAdmin || isDispatchUser) &&
                    detailData?.information?.trim()
                  ) {
                    <span
                      class="ms-3 edit-button"
                      (click)="
                        isAdmin || isDispatchUser
                          ? openInformationTemplate(requestRef)
                          : ''
                      "
                    ></span>
                  }
                } @else {
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    (click)="openInformationTemplate(requestRef)"
                  >
                    Add Client Information
                  </button>
                }
              </dd>
              <!-- @if ((isAdmin || isDispatchUser) && !detailData?.information) {
                <div
                  class="rounded border shadow p-2 mb-2 text-center hover"
                  role="button"
                  (click)="openInformationTemplate(requestRef)"
                >
                  <i class="fa-solid fa-plus"></i>
                </div>
              } -->
            </dl>
          </div>
        }
        @if (isAdmin || isDispatchUser || clientFiles?.length) {
          <div>
            <!--the outer div is necessary for correct padding and matching other div dls-->
            <dl id="clientFiles">
              <dt class="mb-2">
                {{
                  isAdmin || isDispatchUser
                    ? "Client Files [" + clientFiles.length + " / 10 Max]"
                    : "Client Files"
                }}
                @if (isAdmin || isDispatchUser) {
                  <span
                    class="ms-3 add-button"
                    (click)="openFileUploadTemplate(clientFielUploadTemplate)"
                  >
                  </span>
                }
              </dt>
              <dd class="d-flex flex-wrap gap-2 mb-2">
                @for (file of clientFiles; track file; let i = $index) {
                  <div>
                    <div
                      class="d-flex fw-semibold text-primary gap-3 border rounded p-2 align-items-center"
                    >
                      <div
                        (click)="onOpenFile(file)"
                        role="button"
                        class="d-flex align-items-center"
                      >
                        <span class="badge bg-primary me-2">{{
                          file?.extension
                        }}</span>
                        {{ file?.description }}
                      </div>
                      @if (isAdmin || isDispatchUser) {
                        <div class="d-flex mx-1" (click)="deleteFile(file)">
                          <i
                            class="fa-solid fa-minus-circle text-danger fs-5"
                          ></i>
                        </div>
                      }
                    </div>
                  </div>
                }
              </dd>
            </dl>
          </div>
        }
      </div>
      <div class="col-12 col-lg-5">
        <dl id="clientSiteList">
          <div class="d-flex align-items-center mb-2 gap-3">
            <dt>
              Sites [{{ detailData?.company_stats?.site_count || "No Sites" }}]

              @if (isAdmin || isDispatchUser) {
                <span
                  class="ms-3 add-button"
                  id="addNewClientSite"
                  (click)="addNewSite()"
                >
                </span>
              }
            </dt>

            @if (detailData?.company_stats?.site_count > 3) {
              <button
                class="btn btn-outline-primary btn-sm"
                (click)="showAllSites()"
              >
                View All Sites
              </button>
            }
          </div>

          <dd>
            @for (site of siteListData; track site; let i = $index) {
              <div class="cursor-pointer" (click)="openSiteView(site)">
                <div class="rounded border shadow p-2 mb-2 hover">
                  <div class="flex-grow-1">
                    {{ site?.company_name }}
                    <div class="small-font text-secondary">
                      {{ site?.full_address }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </dd>
        </dl>
      </div>
      @if (isAdmin) {
        <div class="col-12 col-lg-2">
          <dl>
            <div class="d-flex gap-3 gap-3 flex-lg-column flex-wrap">
              @if (detailData?.company_stats?.job_exists) {
                <div class="flex-grow-1">
                  <button class="btn w-100 btn-warning" (click)="openJobView()">
                    <i class="fa-solid fa-bell"></i>
                    Responses
                  </button>
                </div>
              }

              @if (detailData?.company_stats?.checkpoint_exists) {
                <div class="flex-grow-1">
                  <button class="btn w-100 btn-primary" (click)="openCPView()">
                    <i class="fa-solid fa-location-dot"></i>
                    Checkpoints
                  </button>
                </div>
              }
              @if (
                detailData?.company_stats?.report_exists ||
                reportRecipientList?.length ||
                patrolReportSchedules?.length
              ) {
                <div class="flex-grow-1">
                  <button
                    class="btn w-100 btn-success"
                    (click)="openReportView()"
                  >
                    <i class="fa-solid fa-file-lines"></i>
                    Report Setup
                  </button>
                </div>
              }
            </div>
          </dl>
        </div>
      }
    </div>

    @if (isAdmin) {
      <div class="row row-cols-1 row-cols-md-3 mt-4" #pc id="pc">
        <div>
          <dl id="clientPatrolReports">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Scheduled Patrol Route Reports</dt>
              </div>
              <div class="d-flex align-items-center">
                <span
                  (click)="openSchedulerTemplate()"
                  role="button"
                  id="editClientPatrolReports"
                  class="edit-button"
                >
                  <span id="edit-button-placeholder d-none"></span>
                </span>
              </div>
            </div>
            <dd>
              @if (patrolReportSchedules?.length < 1) {
                <div class="alert alert-warning mt-2">
                  No one is receiving patrol reports at the client level.
                </div>
              }
              @if (patrolReportSchedules.length > 0) {
                <div class="small text-secondary">
                  <em>Reports for client updates will be sent to:</em>
                </div>
              }
              <table class="table table-hover">
                <tbody>
                  @for (schedule of patrolReportSchedules; track schedule) {
                    <tr
                      class="cursor-pointer"
                      (click)="openSchedulerTemplate(schedule)"
                    >
                      <td>
                        <div class="d-flex">
                          <div class="d-flex align-items-center me-3">
                            <i class="fa-solid fa-calendar-days fa-2x"></i>
                          </div>
                          <div class="flex-grow-1">
                            <div>{{ schedule?.name }}</div>
                            <div class="small-font">
                              {{ schedule?.schedule?.repeat_type | titlecase }}
                              &#64;
                              {{ schedule?.mail_time }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </dd>
          </dl>
        </div>
        <div>
          <dl id="clientJobReports">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Report Recipients</dt>
              </div>
              <div class="d-flex align-items-center">
                <span
                  (click)="openJobReportContactTemplate()"
                  role="button"
                  id="editClientJobReports"
                  class="edit-button"
                >
                  <span id="edit-button-placeholder d-none"></span>
                </span>
              </div>
            </div>
            <dd #jc id="jc">
              @if (reportRecipientList?.length < 1) {
                <div class="alert alert-warning mt-2">
                  No recipients configured for reports at the
                  <span class="fw-semibold">client level</span>.
                </div>
              }

              <table class="table table-hover">
                <tbody>
                  @for (contact of reportRecipientList; track contact) {
                    <tr
                      class="cursor-pointer"
                      (click)="
                        openSiteContactTemplate(contact, detailData, 'jc')
                      "
                    >
                      <td>
                        <div class="d-flex">
                          <div class="d-flex align-items-center me-3">
                            <i class="fa-solid fa-address-book fa-2x"></i>
                          </div>
                          <div class="flex-grow-1">
                            {{ contact?.full_name }}
                            <div class="small-font">
                              {{ contact?.email }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <div>
                @if (clientDetailData?.report_recipients?.length > 3) {
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="
                      reportRecipientList?.length > 3
                        ? (reportRecipientList =
                            clientDetailData?.report_recipients?.slice(0, 3))
                        : (reportRecipientList =
                            clientDetailData?.report_recipients)
                    "
                  >
                    {{
                      reportRecipientList?.length > 3 ? "View Less" : "View All"
                    }}
                  </button>
                }
              </div>
            </dd>
          </dl>
        </div>
      </div>
    }
  </div>
  @if (largeView && isAdmin && clientHistory?.length) {
    <gtapp-gt-table
      id="clientHistory"
      [desktopTableUIData]="clientHistory"
      [desktopTableDetails]="userEventDetailsTableView"
      [otherParams]="{ paginationData: true }"
      (rowClick)="onTableRowClick($event)"
    ></gtapp-gt-table>
  }
  @if (selectedEvent) {
    <gtapp-selected-event-detail
      [selectedEvent]="selectedEvent"
    ></gtapp-selected-event-detail>
  }

  <!-- Templates used to show in Dialogue  -->

  <!-- Client Information POPOVER / DIALOG -->
  <ng-template #requestRef let-data let-requestRef="dialogRef">
    <div class="dialog-box card">
      <div class="card-header">
        Client Information
        <span class="float-end" (click)="requestRef.close()">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </div>

      <!-- Request Detail Section start-->
      <div class="row">
        <div class="col">
          <textarea
            class="form-control"
            placeholder="Client Information"
            cols="20"
            rows="5"
            wrap="hard"
            type="text"
            [(ngModel)]="newInfromation"
          ></textarea>
        </div>
      </div>

      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="requestRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-primary"
            [disabled]="
              newInfromation === detailData?.information ||
              (newInfromation?.length && !newInfromation?.trim())
            "
            (click)="requestRef.close(); updateClientInformation()"
          >
            Update
          </button>
        </div>
      </div>

      <!-- Request Detail Section end-->
    </div>
  </ng-template>

  <!-- Client file Upload DIALOG -->
  <ng-template
    #clientFielUploadTemplate
    let-data
    let-clientFielUploadTemplateRef="dialogRef"
  >
    <div class="dialog-box card">
      <div class="card-header">
        Upload File
        <span
          class="float-end"
          (click)="
            clientFielUploadTemplateRef.close();
            fileUploadError = null;
            fileDescription = null;
            uploadFile = null
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      </div>

      @if (fileUploadError) {
        <div class="mt-3">
          <div class="alert alert-danger">
            {{ fileUploadError }}
          </div>
        </div>
      }
      <div class="col">
        <button
          type="button"
          class="btn btn-md w-100"
          [ngClass]="uploadFile ? 'btn-outline-primary' : 'btn-primary'"
          (click)="selectFile()"
        >
          {{ uploadFile ? "Change File" : "Upload File" }}
        </button>

        <input
          #fileInput
          id="fileInput"
          style="display: none; cursor: pointer"
          type="file"
          accept=".pdf, .jpg, .jpeg, .png, .webp, .avif"
          (change)="handleFileInput($event)"
        />
      </div>

      <div class="form-floating mt-3">
        <input
          class="form-control"
          placeholder="File Description"
          required
          maxlength="30"
          type="text"
          [(ngModel)]="fileDescription"
        /><label>File Description</label>
      </div>

      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="
              clientFielUploadTemplateRef.close();
              fileUploadError = null;
              fileDescription = null;
              uploadFile = null
            "
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-lg w-100 btn-primary"
            [disabled]="!uploadFile || !fileDescription"
            (click)="onUploadFile(); clientFielUploadTemplateRef.close()"
          >
            Upload {{ uploadFile?.name }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template
  #addNewPrimeContractorUser
  let-addNewPrimeContractorUserRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      User Details
      <span
        class="float-end"
        (click)="addNewPrimeContractorUserRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (data?.permanentSlotsAvailable) {
      <form [formGroup]="primeContractorUserForm">
        <div class="d-flex flex-column gap-2 mb-3">
          <div class="input-group">
            <div class="form-floating">
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                autocomplete="off"
                placeholder="Enter email"
                autofocus
                autocapitalize="off"
                (blur)="emailExistsCheck()"
                [class.is-invalid]="
                  primeContractorUserForm.controls['email'].invalid &&
                  primeContractorUserForm.controls['email'].touched
                "
              />
              <label for="email">Email</label>
            </div>
            @if (primeContractorUserForm.value.email) {
              <span class="input-group-text" (click)="clearField('email')">
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          @if (
            primeContractorUserForm.controls["email"].hasError("alreadyExists")
          ) {
            <div class="text-danger small-font">
              This user is already associated with this account.
            </div>
          } @else if (
            primeContractorUserForm.controls["email"].invalid &&
            primeContractorUserForm.controls["email"].touched
          ) {
            <div class="text-danger small-font">Invalid email address</div>
          }
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                id="first_name"
                formControlName="first_name"
                autocomplete="off"
                placeholder="First Name"
                (input)="updateDisplayName()"
                autofocus
                [class.is-invalid]="
                  primeContractorUserForm.controls['first_name'].invalid &&
                  primeContractorUserForm.controls['first_name'].touched
                "
              />
              <label>First Name</label>
            </div>
            @if (primeContractorUserForm.value.first_name) {
              <span class="input-group-text" (click)="clearField('first_name')">
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                id="last_name"
                formControlName="last_name"
                autocomplete="off"
                placeholder="Last Name"
                (input)="updateDisplayName()"
                autofocus
                [class.is-invalid]="
                  primeContractorUserForm.controls['last_name'].invalid &&
                  primeContractorUserForm.controls['last_name'].touched
                "
              />
              <label>Last Name</label>
            </div>
            @if (primeContractorUserForm.value.last_name) {
              <span class="input-group-text" (click)="clearField('last_name')">
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                id="display_name"
                formControlName="display_name"
                autocomplete="off"
                placeholder="Display Name"
                autofocus
              />
              <label>Display Name</label>
            </div>
            @if (primeContractorUserForm.value.display_name) {
              <span
                class="input-group-text"
                (click)="clearField('display_name')"
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                minlength="7"
                maxlength="10"
                (input)="mobileNumberCheck()"
                id="contact_number"
                formControlName="contact_number"
                autocomplete="off"
                placeholder="Contact Number"
                autofocus
                [class.is-invalid]="
                  primeContractorUserForm.controls['contact_number'].invalid &&
                  primeContractorUserForm.controls['contact_number'].touched
                "
              />
              <label>Contact Number</label>
            </div>
            @if (primeContractorUserForm.value.contact_number) {
              <span
                class="input-group-text"
                (click)="clearField('contact_number')"
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>

          <div class="row row-cols-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-dark w-100"
                (click)="addNewPrimeContractorUserRef.close(false)"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="submit"
                [disabled]="!primeContractorUserForm.valid"
                class="btn btn-lg btn-success w-100"
                (click)="addNewPrimeContractorUserRef.close(true)"
              >
                Add User
              </button>
            </div>
          </div>
        </div>
      </form>
    } @else {
      @if (data?.isSubscriberAdmin) {
        <div
          class="p-3 d-flex justify-content-around align-items-center"
          (click)="addMoreUserSlots()"
        >
          Additional User Required
          <button class="btn btn-outline-success bg-success-subtle fw-semibold">
            Purchase Additional User
          </button>
        </div>
      } @else {
        <div class="alert alert-warning">
          Unable to make user permanent, allocation exhausted.
        </div>
      }
    }
  </div>
</ng-template>
